import http from '@/utils/http'
import { PATH_SDR, PATH_USER_CENTER } from './consts'
import { ChessStatReq, RecordReq, StatReq } from './types/history'

export const getRecords = (data: RecordReq) => {
  return http.get(`${PATH_SDR}/v1/records`, data)
}

export const getRecordById = (id: string) => {
  return http.get(`${PATH_SDR}/v1/record?session_id=${id}`)
}

export const getStatById = (data: StatReq) => {
  return http.post(`${PATH_SDR}/v1/stat`, data)
}

// 查询关卡
export const getBusinessChessStat = (data: ChessStatReq) => {
  return http.get(`${PATH_USER_CENTER}/v2/cmcc-h5/business/chess/stat`, data)
}
